import Number from './Number.vue'

const VueNumber = {
  install: function (Vue) {
    Vue.component('number', Number)
  }
}

export default VueNumber

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueNumber)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-number-animation/index.js
// module id = pL1p
// module chunks = 40